import React, { createContext, useContext, useState } from "react";

interface CopilotContextType {
  copilotOpen: boolean;
  setCopilotOpen: (open: boolean) => void;
  toggleCopilot: () => void;
}

const CopilotContext = createContext<CopilotContextType | undefined>(undefined);

export const CopilotProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [copilotOpen, setCopilotOpen] = useState(true);
  const toggleCopilot = () => setCopilotOpen((v) => !v);
  return (
    <CopilotContext.Provider value={{ copilotOpen, setCopilotOpen, toggleCopilot }}>
      {children}
    </CopilotContext.Provider>
  );
};

export const useCopilot = () => {
  const ctx = useContext(CopilotContext);
  if (!ctx) throw new Error("useCopilot must be used within CopilotProvider");
  return ctx;
};
